<template>
  <div class="view-container">
    <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :modal-append-to-body="false" :before-close="handleClose" :title="openType">
      <BjDivider>{{$t('billingPage.transactionForm')}}</BjDivider>
      <el-form v-if="drawer" ref="form" label-position="top" :model="form" :rules="rules" label-width="160px" style="padding:16px;">
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.InvoicesNo')" prop="invoiceId">
            <BjInputNumber v-model="form.invoiceId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.InvoicesNo')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.Client')" prop="clientCode">
            <BjSelectLov v-model="form.clientCode" :option-list="clientCodeList" :placeholder="$t('chooseText')" @change="getCategoryCodeList" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.Category')" prop="categoryCode">
            <BjSelectLov v-model="form.categoryCode" :disabled="!form.clientCode" :option-list="categoryCodeList" :placeholder="$t('chooseText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.quantity')" prop="quantity">
            <BjInputNumber v-model="form.quantity" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.PurchaseOrder')" prop="poId">
            <BjInput v-model="form.poId" :placeholder="$t('inputText')" clearable :disabled="poDIS" @change="poDISFUN" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.OrderNumber')" prop="orderId">
            <BjInput v-model="form.orderId" :placeholder="$t('inputText')" clearable :disabled="orderDIS" @change="orderDISFUN" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.ReturnOrder')" prop="returnOrderId">
            <BjInput v-model="form.returnOrderId" :placeholder="$t('inputText')" clearable :disabled="returnOrderDIS" @change="returnOrderDISFUN" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.description')" prop="description">
            <BjInput v-model="form.description" type="textarea" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="danger" @click="onCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onComfirm">{{ $t('okText') }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { billApi } from '@/api';
const getDefaultForm = () => {
  return {
    clientCode: null,
    categoryCode: null,
    invoiceId: null,
    quantity: null,
    poId: null,
    orderId: null,
    returnOrderId: null,
    description: null,
  };
};
export default {
  data() {
    return {
      colSpan:24,
      // 表单参数
      drawer: false,
      openType: '',
      form: getDefaultForm(),
      rules: {
        clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        categoryCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        invoiceId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        quantity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      clientCodeList:[],
      categoryCodeList:[],
      poDIS: false,
      orderDIS: false,
      returnOrderDIS: false,
    };
  },
  methods: {
    // 获取所有客户信息列表
    getClientInfoList() {
      billApi.getClientInfoList().then(res => {
        res.data.forEach(item => {
          item.label = `${item.label} - ${item.value}`;
        });
        this.clientCodeList = res.data;
      });
    },
    // 获取所有增值服务收费项
    getAllAdditionalCharges() {
      billApi.getClientCharges({clientCode: this.form.clientCode}).then(res => {
        this.categoryCodeList = res.data;
      });
    },
    getCategoryCodeList(val) {
      billApi.getClientCharges({clientCode: val}).then(res => {
        this.categoryCodeList = res.data;
      });
    },
    poDISFUN(e) {
      if (e) {
        this.orderDIS = true;
        this.returnOrderDIS = true;
      } else {
        this.orderDIS = false;
        this.returnOrderDIS = false;
      }
    },
    orderDISFUN(e) {
      if (e) {
        this.poDIS = true;
        this.returnOrderDIS = true;
      } else {
        this.poDIS = false;
        this.returnOrderDIS = false;
      }
    },
    returnOrderDISFUN(e) {
      if (e) {
        this.poDIS = true;
        this.orderDIS = true;
      } else {
        this.poDIS = false;
        this.orderDIS = false;
      }
    },
    // 确定按钮
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const obj = Object.assign({}, this.form);
          this.$emit('handleConfirm', obj);
          this.hide();
        }
      });
    },
    // 取消按钮
    onCancel() {
      this.hide();
      this.form = getDefaultForm();
    },
    // 弹窗关闭
    hide() {
      this.drawer = false;
    },
    /** 关闭弹窗 */
    handleClose(done) {
      this.onCancel();
    },
  },
};
</script>
<style lang="scss">
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
